export const ENTRIES = [
  {
    id: 'amazon',
    tab: 'Amazon',
    role: 'Incoming Software Engineer Intern',
    org: 'Amazon',
    logo: '/logos/amazon.png',
    location: 'Seattle, WA',
    dates: 'Fall 2026',
    bullets: [
      'Joining the Delivery Experience org on backend systems for Amazon deliveries',
    ],
    skills: ['Backend', 'Distributed Systems'],
  },
  {
    id: 'mongodb',
    tab: 'MongoDB',
    role: 'Software Engineer Intern',
    org: 'MongoDB',
    logo: '/logos/mongodb.jpg',
    location: 'New York, NY',
    dates: 'Jun 2025 - Aug 2025',
    bullets: [
      'Migrated a Lambda monolith to microservices — 100% faster startup, 50+ endpoints consolidated',
      'Built a RESTful API with JWT auth handling 12K+ requests/day',
      'Set up CI/CD with Docker, Jenkins, and Kubernetes pipelines',
      'Ran production infra on AWS: Lambda, ECS/EKS, S3, CloudWatch',
    ],
    skills: ['Python', 'Docker', 'Kubernetes', 'AWS', 'Celery/Redis'],
  },
  {
    id: 'rakuten',
    tab: 'Rakuten',
    role: 'Software Engineer Intern',
    org: 'Rakuten',
    logo: '/logos/rakuten.png',
    location: 'San Mateo, CA',
    dates: 'Jan 2025 - May 2025',
    bullets: [
      'Built an AI onboarding assistant (Whisper + LLMs) — 120% faster activation',
      'Shipped AI APIs for intent classification and retrieval routing',
      'Designed multi-step AI agents with tool use, memory, fallback logic',
      'Built Spark/Hadoop ETL pipelines — 60% lower data latency',
    ],
    skills: ['Python', 'LLMs', 'Spark', 'React Native', 'TypeScript'],
  },
  {
    id: 'alaska',
    tab: 'Alaska Airlines',
    role: 'Software Engineer Intern',
    org: 'Alaska Airlines',
    logo: '/logos/alaska.jpg',
    location: 'Seattle, WA',
    dates: 'Jun 2024 - Sep 2024',
    bullets: [
      'Built an LLM chatbot (GPT + LangChain) for support — +25% efficiency',
      'Shipped app check-in features (React Native + Go) — 10% faster check-in',
      'Built the front-end for a new seat-selection map (React + TypeScript)',
      'Built a flight status notification system — 20% fewer delays',
    ],
    skills: ['React Native', 'Go', 'FastAPI', 'LangChain', 'AWS'],
  },
  {
    id: 'vibescope',
    tab: 'Vibescope',
    role: 'Project',
    org: 'Vibescope',
    location: 'Berkeley, CA',
    dates: 'Jun 2023',
    bullets: [
      'Built YouTube comment sentiment analysis with Hume AI + Flask',
      'Pulled comment data via the YouTube API on AWS Lambda',
      'Built the React frontend for results',
    ],
    skills: ['Python', 'Flask', 'Node.js', 'AWS Lambda', 'React'],
    link: { href: 'https://devpost.com/software/vibescope', label: 'devpost' },
  },
  {
    id: 'education',
    tab: 'Education',
    role: 'MS in Computer Science',
    org: 'University of Illinois Urbana-Champaign',
    location: 'Champaign, IL',
    dates: 'Dec 2027',
    bullets: [
      'BS in Computer Science, Minor in Business Analytics, GPA 3.6 — University of California, Riverside (Jun 2026)',
    ],
    skills: ['C/C++', 'Python', 'Java', 'Go', 'JavaScript/TypeScript'],
  },
];
